import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useMyOrdersQuery } from '../../redux/api/bookingApi';
import { formatPKR, getTier } from './rideConfig';
import '../../css/ride.css';

const TIER_ICON = { Suzuki: 'bi-truck-front', Mazda: 'bi-truck', Shehzore: 'bi-truck-flatbed' };

const badgeTone = (status) => {
  if (status === 'Job Completed Successfully') return 'green';
  if (status === 'Booking Canceled') return 'red';
  if (status === 'Finding Driver' || status === 'Vehicle not dispatched yet') return 'amber';
  if (status?.includes('Dispatched') || status?.includes('left')) return 'blue';
  if (status?.includes('Arrived')) return 'green';
  return 'gray';
};

export default function RideRides() {
  const navigate = useNavigate();
  const { isAuthenticated } = useSelector((s) => s.auth);
  const { data, isLoading } = useMyOrdersQuery(undefined, { skip: !isAuthenticated, pollingInterval: 30000 });
  const rides = data?.orders || [];

  return (
    <>
      <div className="ride-topbar">
        <button className="ride-icon-btn" onClick={() => navigate(-1)} aria-label="Back">
          <i className="bi bi-chevron-left" />
        </button>
        <div className="ride-brand-pill"><span>My rides</span></div>
        <Link to="/ride/account" className="ride-icon-btn" aria-label="Account">
          <i className="bi bi-person" />
        </Link>
      </div>

      <div className="ride-panel" style={{ background: 'var(--color-bg)' }}>
        <div className="ride-panel-inner">
          {isLoading && (
            <>
              <div className="ride-spinner mx-auto my-5" />
            </>
          )}

          {!isLoading && rides.length === 0 && (
            <div className="ride-empty mt-5">
              <i className="bi bi-cash-stack" />
              <div className="h">No rides yet</div>
              <div className="p">Your trips will show up here once you book.</div>
              <Link to="/ride" className="ride-cta accent mt-4" style={{ width: 'auto', display: 'inline-flex', padding: '12px 28px', textDecoration: 'none' }}>
                Book your first ride
              </Link>
            </div>
          )}

          {rides.map((r) => {
            const veh = r.userAddressInfo?.vehicle || r.orderItems || 'Suzuki';
            const tier = getTier(veh);
            return (
              <Link
                key={r._id}
                to={`/ride/track/${r._id}`}
                className="ride-hist-card"
                style={{ marginBottom: 'var(--space-3)', textDecoration: 'none' }}
              >
                <div className="ride-hist-top">
                  <span className="ride-hist-vehicle">
                    <i className={`bi ${TIER_ICON[veh] || 'bi-truck'}`} style={{ color: 'var(--ride-navy)', fontSize: '1.2rem' }} />
                    {tier.name}
                  </span>
                  <span className={`ride-badge ${badgeTone(r.orderStatus)}`}>{r.orderStatus}</span>
                </div>
                <div className="ride-hist-route">
                  <div className="leg"><i className="bi bi-circle-fill" style={{ color: 'var(--color-success)', fontSize: '.55rem' }} /> <span>{r.googleMap?.origin}</span></div>
                  <div className="leg"><i className="bi bi-circle-fill" style={{ color: 'var(--color-danger)', fontSize: '.55rem' }} /> <span>{r.googleMap?.destination}</span></div>
                </div>
                <div className="ride-hist-foot">
                  <span>{r.createdAt ? new Date(r.createdAt).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' }) : ''}{r.googleMap?.distance ? ` · ${r.googleMap.distance}` : ''}</span>
                  <span className="ride-hist-price">{formatPKR(r.totalAmount)}</span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </>
  );
}
